module.exports = __webpack_public_path__ + "static/media/po-reman-7.ef6db513.png";